import cx from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import type { ActiveTab } from "../types";
import style from "./voteTabs.module.css";

type VoteTabsProps = { activeTab: ActiveTab; onSelect: (activetab: ActiveTab) => void };

export function VoteTabs({ activeTab, onSelect }: VoteTabsProps) {
    const { t } = useTranslation();
    return (
        <div className={style.tabsWrapper}>
            <div
                className={cx(style.voteTab, style.voteTabNew, {
                    [style.active]: activeTab === "new",
                })}
                onMouseUp={() => onSelect("new")}
            >
                <p>{t("vote.tabNew")}</p>
            </div>
            <div
                className={cx(style.voteTab, style.voteTabPast, {
                    [style.active]: activeTab === "past",
                })}
                onMouseUp={() => onSelect("past")}
            >
                <p>{t("vote.tabPast")}</p>
            </div>
        </div>
    );
}
